import { formatDate } from '@angular/common';
import { OnInit, Component, ViewChild, Inject } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { catchError, finalize, tap, throwError } from 'rxjs';
import { ApiservicesService } from 'src/app/apiservices.service';
import { UserTopComponent } from '../../../components/user-top/user-top.component';
import { EncryptdecryptService } from '../../../services/encryptdecrypt.service';
import { APP_CONFIG, AppConfig } from '../../../app-config';
import { WindowFormService } from '../../../services/window-form.service';
import { NoticeDialogService } from 'src/app/components/shared/notice-dialog.service';

@Component({
  providers: [UserTopComponent],
  selector: 'app-status-e-borang',
  templateUrl: './status-e-borang.component.html',
  styleUrls: ['./status-e-borang.component.css']
})


export class StatusEBorangComponent implements OnInit {
  //UI Status Variables
  InfoStatus: boolean = false;
  SearchStatus: boolean = false;
  IsAdmin: boolean = false;

  //Open Window
  openedWindowStatus: any = null;

  //UI Input Variables
  FormStatusInput: any = "";
  YearAssessmentInput: any = "";
  IDTypeInput: any = "";
  IDNoInput: any = "";
  DistributeInput: any = "";
  CKMYearAssessmentInput: any = "";

  //UI Pagination Variables
  FormStatus: any = "";
  IDType: any = "";
  IDNo: any = "";
  YearAssessment: any = "";
  PageNum: any = "";
  PageSize: any = "";

  //UI CKM Variables
  CKMTINView: any = "";

  //UI Distribute Variables
  NameView: any = "";
  TaxRefNumView: any = "";
  FormTypeView: any = "";
  RegisterDateView: any = "";
  SubmittedDateView: any = "";
  TaxAgentNameView: any = "";
  TaxAgentIDView: any = "";
  StaffNameView: any = "";
  TaxReturnFormIDView: any = "";
  OldStaffID: any = "";
  DistributeList: any;

  //UI Reset Variables
  TaxReturnFormID: any = "";

  //Alert Variables
  AlertType: string = "";
  AlertStatus: boolean = false;
  AlertMessage: string = "";

  //Reset Form Variable
  TaxRefNumResetForm: any = "";
  FormTypeResetForm: any = "";
  YearAssessmentResetForm: any = "";

  //SessionData
  SessionRoles: any = [];
  SessionFirmID: any = "";
  SessionStaffID: any = "";
  SessionStaffIDNo: any = "";
  SessionIPAddress: any;

  //Datatable Variables
  displayedColumns = ['pembayarcukai', 'jenisborang', 'tin', 'caw', 'tarikhdaftar', 'tarikhhantar', 'namastaf','namaejen', 'action'];
  Records: any = new Array;
  RecordCount: any = "";
  LoaderStatus: boolean = false;
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  dataSource = new MatTableDataSource();

  isSelectDisabled: boolean = false;

  // Config property for HTML access
  beLoginUrl: string = '';
  yearBeStartOauth: number = 2025; // <-- added

  constructor(
    private apiServices: ApiservicesService,
    private top: UserTopComponent,
    private encryptDecryptService: EncryptdecryptService,
    @Inject(APP_CONFIG) private config: AppConfig,
    private windowForm: WindowFormService,
    private noticeDialog: NoticeDialogService 
  ) {
    this.beLoginUrl = config.beLoginUrl;      
    this.yearBeStartOauth = config.YearBeStartOauth ?? 2025; // <-- load from app-config
  }

  ngOnInit(): void {
    this.SessionFirmID = this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || '');
    this.SessionStaffID = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffID') || '');
    this.SessionStaffIDNo = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffIDNo') || '');
    this.top.updateTotal();
  }

  //asad tambah
  onChangeIDType(IDTypeInput:any) {
    this.IDNoInput = "";
    if (IDTypeInput == "8")
    {
      this.isSelectDisabled = true;
      this.InfoStatus = true;
      this.YearAssessmentInput = "";
    }
    else {
      this.ResetValue();
    }
 
  }
  paginatorEvent(e: PageEvent) {
    this.PageSize = e.pageSize;
    this.PageNum = e.pageIndex;
    this.GetData(this.FormStatus, this.IDType, this.IDNo, this.YearAssessment, this.SessionFirmID, this.SessionStaffID, e.pageIndex, e.pageSize);
  }
  Submit(FormStatus: any, IDType:any, IDNo: any, YearAssessment: any) {
    this.ResetValue();
    this.LoaderStatus = true;
    if (IDType === '8') {
      this.isSelectDisabled = true;
      this.InfoStatus = true;
    }
    if (this.CheckNull(FormStatus) && this.CheckNull(YearAssessment) && this.CheckNull(IDType) && this.CheckNull(IDNo)) {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.SearchStatus = false;
      this.LoaderStatus = false;
    } else if (this.CheckNull(FormStatus)) {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.SearchStatus = false;
      this.LoaderStatus = false;
    }
    //  //asad tambah
    //else if (!this.CheckNull(FormStatus) && !this.CheckNull(IDType) && !this.CheckNull(IDNo) && this.CheckNull(YearAssessment)) {
    //  if (isNaN(IDNo)) {
    //    this.AlertType = "fail";
    //    this.AlertMessage = "Sila masukkan butiran yang tepat";
    //    this.AlertStatus = true;
    //    setTimeout(() => {
    //      this.AlertStatus = false;
    //    }, 1001);
    //    this.SearchStatus = false;
    //    this.LoaderStatus = false;
    //    this.isSelectDisabled = true;
    //  }
    //  else {
    //    this.FormStatus = FormStatus;
    //    this.IDType = IDType;
    //    this.IDNo = IDNo;
    //    this.YearAssessment = YearAssessment;
    //    this.isSelectDisabled = true;
    //    this.GetData(FormStatus, IDType, IDNo, null, this.SessionFirmID, this.SessionStaffID, null, null);
    //  }

    //}

    else if (!this.CheckNull(YearAssessment) && !this.CheckNull(IDType) && !this.CheckNull(IDNo)) {
      if ((IDType === '6' && isNaN(IDNo)) || (IDType === '1' && isNaN(IDNo)) || (IDType === '7' && isNaN(IDNo)) || (IDType === '8' && isNaN(IDNo))) {
        this.AlertType = "fail";
        this.AlertMessage = "Sila masukkan butiran yang tepat";
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.SearchStatus = false;
        this.LoaderStatus = false;
      } else {
        this.FormStatus = FormStatus;
        this.IDType = IDType;
        this.IDNo = IDNo;
        this.YearAssessment = YearAssessment;
        this.GetData(FormStatus, IDType, IDNo, YearAssessment, this.SessionFirmID, this.SessionStaffID, null, null);
      }
    } else if (!this.CheckNull(YearAssessment) && this.CheckNull(IDType) && this.CheckNull(IDNo)) {
      this.FormStatus = FormStatus;
      this.IDType = null;
      this.IDNo = null;
      this.YearAssessment = YearAssessment;
      this.GetData(FormStatus, null, null, YearAssessment, this.SessionFirmID, this.SessionStaffID,null,null);
    } else if (this.CheckNull(YearAssessment) && !this.CheckNull(IDType) && !this.CheckNull(IDNo)) {
      if ((IDType === '6' && isNaN(IDNo)) || (IDType === '1' && isNaN(IDNo)) || (IDType === '7' && isNaN(IDNo)) || (IDType === '8' && isNaN(IDNo))) {
        this.AlertType = "fail";
        this.AlertMessage = "Sila masukkan butiran yang tepat";
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.SearchStatus = false;
        this.LoaderStatus = false;
      } else {
        this.FormStatus = FormStatus;
        this.IDType = IDType;
        this.IDNo = IDNo;
        this.YearAssessment = null;
        this.GetData(FormStatus, IDType, IDNo, null, this.SessionFirmID, this.SessionStaffID, null, null);
      }
    } else if (this.CheckNull(YearAssessment) && this.CheckNull(IDType) && this.CheckNull(IDNo)) {
      this.FormStatus = FormStatus;
      this.IDType = null;
      this.IDNo = null;
      this.YearAssessment = null;
      this.GetData(FormStatus, null, null, null, this.SessionFirmID, this.SessionStaffID, null, null);
    } else {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.SearchStatus = false;
      this.LoaderStatus = false;
    }
  }
  async GetData(FormStatus: any, IDType:any, IDNo: any, YearAssessment: any, FirmID: any, StaffID: any, PageNum: any, PageSize: any) {
    this.LoaderStatus = true;
    let Params = {};
    let tempFormStatus = FormStatus === "true" || FormStatus === true ? true : false;
    if (YearAssessment !== null && IDType !== null)
    {
      Params = {
        "Submit": tempFormStatus,
        "IDType": String(IDType),
        "IDNo": String(IDNo),
        "Tahun": Number(YearAssessment),
        "FirmID": Number(FirmID),
        "StaffID": Number(StaffID),
        "Page": PageNum === null ? 0 : PageNum,
        "Size": PageSize === null ? 10 : PageSize
      }
    } else if (YearAssessment !== null && IDType === null) {
      Params = {
        "Submit": tempFormStatus,
        "Tahun": Number(YearAssessment),
        "FirmID": Number(FirmID),
        "StaffID": Number(StaffID),
        "Page": PageNum === null ? 0 : PageNum,
        "Size": PageSize === null ? 10 : PageSize
      }
    } else if (YearAssessment === null && IDType !== null) {
      Params = {
        "Submit": tempFormStatus,
        "IDType": String(IDType),
        "IDNo": String(IDNo),
        "FirmID": Number(FirmID),
        "StaffID": Number(StaffID),
        "Page": PageNum === null ? 0 : PageNum,
        "Size": PageSize === null ? 10 : PageSize
      }
    } else {
      Params = {
        "Submit": tempFormStatus,
        "FirmID": Number(FirmID),
        "StaffID": Number(StaffID),
        "Page": PageNum === null ? 0 : PageNum,
        "Size": PageSize === null ? 10 : PageSize
      }
    }
    const result = await this.apiServices.GetStatusBorang(Params);

    
    if (result.totalRecord === 0)
    {
      this.dataSource = new MatTableDataSource();
      this.LoaderStatus = false;
      this.SearchStatus = true;
    } else {
      // Change jenis_Borang dynamically
      const mapping: any = {
        PE: "BNT BE",
        PB: "BNT B"
      };

      result.listForm.forEach((currentValue: any, index: any) => {
        result.listForm[index].dateSubmitted = result.listForm[index].dateSubmitted === "" || result.listForm[index].dateSubmitted === null || result.listForm[index].dateSubmitted === undefined ? "N/A" : formatDate(result.listForm[index].dateSubmitted, 'dd-MMM-yyyy h:mm:ss a', "en-US");;
        result.listForm[index].dateRegistered = (result.listForm[index].dateRegistered == null || result.listForm[index].dateRegistered == "") ? "N/A" : formatDate(result.listForm[index].dateRegistered, 'dd-MMM-yyyy h:mm:ss a', "en-US");
      });


      // Create new property
      result.listForm.forEach((item: any) => {
        const parts = item.formType.split(' ');

        const formCode = parts[0];      // PE
        const year = parts.slice(1).join(' '); // 2025

        item.namaBorang = mapping[formCode]
          ? `${mapping[formCode]} ${year}`
          : item.formType;
      });

      this.SessionRoles = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffRoles') || '');
      const Roles = JSON.parse(this.SessionRoles);
      Roles.forEach((currentValue: any, index: any) => {
        if (Roles[index] === "0201") {
          this.IsAdmin = true;
        }
      });
      this.dataSource = new MatTableDataSource(result.listForm);
      this.RecordCount = result.totalRecord;
      this.SearchStatus = true;
    }
    this.LoaderStatus = false;
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  CheckNull(value: string): boolean {
    if (value == null || value == "") {
      return true;
    } else {
      return false;
    }
  }
  ResetValue() {
    this.InfoStatus = false;
    this.SearchStatus = false;
    this.AlertType = "";
    this.AlertStatus = false;
    this.AlertMessage = "";

    this.Records = [];
    this.RecordCount = "";
    this.LoaderStatus = false;
    this.IsAdmin = false;

    this.TaxRefNumResetForm = "";
    this.FormTypeResetForm = "";
    this.YearAssessmentResetForm = "";

    this.NameView = "";
    this.TaxRefNumView = "";
    this.FormTypeView = "";
    this.RegisterDateView = "";
    this.SubmittedDateView = "";
    this.TaxAgentNameView = "";
    this.TaxAgentIDView = "";
    this.StaffNameView = "";
    this.DistributeInput = "";
    this.OldStaffID = "";

    this.TaxReturnFormID = "";

    this.CKMTINView = "";

    this.TaxRefNumResetForm = "";
    this.FormTypeResetForm = "";
    this.YearAssessmentResetForm = "";
    this.isSelectDisabled = false;
  }
  Semula() {
    this.InfoStatus = false;
    this.SearchStatus = false;
    this.FormStatusInput = "";
    this.YearAssessmentInput = "";
    this.CKMYearAssessmentInput = "";
    this.isSelectDisabled = false;
    this.FormStatus = "";
    this.IDType = "";
    this.IDNo = "";
    this.YearAssessment = "";
    this.IDTypeInput = "";
    this.IDNoInput = "";

    this.NameView = "";
    this.TaxRefNumView = "";
    this.FormTypeView = "";
    this.RegisterDateView = "";
    this.SubmittedDateView = "";
    this.TaxAgentNameView = "";
    this.StaffNameView= "";
    this.DistributeInput = "";
    this.DistributeList = new Array;

    this.TaxReturnFormID = "";

    this.AlertType = "";
    this.AlertStatus = false;
    this.AlertMessage = "";

    this.Records = new Array;
    this.RecordCount = "";
    this.LoaderStatus = false;
    this.dataSource = new MatTableDataSource();
  }
  DistributeShow(TaxReturnFormID:any,OldStaffID: any, TaxPayerName: any, FormType: any, AgentID: any, TaxAgentName: any, TaxRefNum: any, RegisterDate: any, SubmittedDate: any, StaffName: any, FormName: any) {
    this.OldStaffID = OldStaffID;
    this.NameView = TaxPayerName;
    this.TaxRefNumView = TaxRefNum;
    this.FormTypeView = FormName;
    this.RegisterDateView = RegisterDate;
    this.SubmittedDateView = SubmittedDate;
    this.TaxAgentNameView = TaxAgentName;
    this.StaffNameView = StaffName;
    this.TaxAgentIDView = AgentID;
    this.TaxReturnFormIDView = TaxReturnFormID;
    this.GetStaff(TaxReturnFormID, this.SessionStaffID, this.SessionFirmID);
  }
  async GetStaff(TaxReturnFormID: any, StaffID: any, FirmID: any) {
    let Params = {};
    if (sessionStorage.getItem('TaxAgentID') === null) {
      Params = {
        "FirmID": FirmID,
        "TaxReturnFormID": TaxReturnFormID,
        "StaffID": StaffID
      }
    } else {
      Params = {
        "FirmID": FirmID,
        "TaxReturnFormID": TaxReturnFormID,
        "StaffID": StaffID,
        "TaxAgentID": this.encryptDecryptService.decrypt(sessionStorage.getItem('TaxAgentID') || '')
      }
    }
    const result = await this.apiServices.GetDistributeList(Params);
    if (result.length > 0) {
      result.forEach((currentValue: any, index: any) => {
        switch (result[index].staffRole) {
          case "0202":
            result[index].staffName = result[index].staffName + " - (Penyelia)";
            break;
          case "0203":
            result[index].staffName = result[index].staffName + " - (Staf)";
            break;
          case "0204":
            result[index].staffName = result[index].staffName + " - (Ejen Cukai)";
            break;
          default:
            result[index].staffName = result[index].staffName;
            break;
        }
      });
    }
    this.DistributeList = result;
  }
  async DistributeSubmit(StaffID: any, TaxReturnFormID:any, TaxRefNum: any, FormType: any, TaxAgentID:any) {
    this.LoaderStatus = true;
    if (StaffID === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila isi butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      let Params = {
        "StaffID": StaffID,
        "ActionStaffID": this.SessionStaffID,
        "FirmID": this.SessionFirmID,
        "TaxReturnFormID": TaxReturnFormID,
        "ModuleName": "Pembayar Cukai",
        "PageName": "Status e-Borang",
      }
      const result = await this.apiServices.DistributeForm(Params);
      if (result.hasError) {
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
      } else {
        this.LoaderStatus = false;
        this.GetData(this.FormStatus, this.IDType, this.IDNo, this.YearAssessment, this.SessionFirmID, this.SessionStaffID, null, null);
        this.AlertType = "success";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
      }
    }
  }
  ResetFormValue(TaxRefNum: any, FormType: any, YearAssessment: any) {
    this.TaxRefNumResetForm = TaxRefNum;
    this.FormTypeResetForm = FormType;
    this.YearAssessmentResetForm = YearAssessment;
  }
  async ResetForm(TaxRefNum: any, FormType: any, YearAssessment: any) {
    this.LoaderStatus = true;

  
    //asad tambah checking reset cp8d tidak dibenarkan
    if (FormType == "CP8D" || FormType == "CP8D 2023") {
      this.AlertType = "fail";
      this.AlertMessage = "Tindakan set semula tidak dapat dilakukan bagi jenis borang e-CP8D.";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    }
    else {
      let Params = {
        "ClientID": String(TaxRefNum),
        "FormType": FormType,
        "YearAssessment": YearAssessment,
        "FirmID": Number(this.SessionFirmID),
        "StaffID": Number(this.SessionStaffID),
        "ModuleName": "Pembayar Cukai",
        "PageName": "Status e-Borang",
      }
      const result = await this.apiServices.ResetForm(Params);
      if (result.hasError) {
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
      } else {
        this.AlertType = "success";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.paginator.firstPage();
        this.GetData(this.FormStatus, this.IDType, this.IDNo, this.YearAssessment, this.SessionFirmID, this.SessionStaffID, null, null);
      }
    }
 
  }
  async GetAcknowledment(FormType: any, YearAssessment: any, TaxRefNum: any) {
    
    // if (FormType === 'BE 2025' || FormType === 'B 2025' || FormType === 'BT 2025' || FormType === 'M 2025' || FormType === 'MT 2025') {
    //   this.noticeDialog.blockButton();
    //   return;
    // }

    this.LoaderStatus = true;
    let AmendmentCP204A = "";
    if (FormType.includes("CP204A")) {
      AmendmentCP204A = FormType.substring(FormType.lastIndexOf("-") + 1);
      FormType = FormType.substring(0, FormType.indexOf("-"));
    } else if (FormType.includes("CP204")) {
      FormType = FormType.slice(0, 5);
    } else if (FormType.includes("CP204B")) {
      FormType = FormType.slice(0, 6);
    } else if (FormType.includes("C1")) {
      FormType = FormType.slice(0, 2);
    } else if (FormType.includes("LE1")) {
      FormType = FormType.slice(0, 3);
    } else if (FormType.includes("CP22")) {
      FormType = FormType;
    } else {
      FormType = FormType.replace(/[0-9]/g, '').trim();
    }
  
    const result = await this.apiServices.GetAcknowledment(this.SessionFirmID, FormType, YearAssessment, TaxRefNum, AmendmentCP204A, this.SessionStaffIDNo);

    if (result.hasError) {
      this.AlertType = "fail";
      this.AlertMessage = result.errMsg;
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      this.LoaderStatus = false;
      this.GoAcknowledgment(result.url, result.paramBody);
    }
  }
  GoAcknowledgment(ParamUrl: any, ParamBody: any) {
    
    const existingForm = document.getElementById("semakan-post-form");
    if (existingForm) {
      existingForm.remove();
    }
    
    const form = document.createElement("form");
    form.id = "semakan-post-form";
    form.target = "Map";
    form.method = "POST";
    form.action = ParamUrl;

    for (let x = 0; x < ParamBody.length; x++) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = ParamBody[x].paramName;
      input.value = ParamBody[x].paramValue;
      form.appendChild(input);
    }

    document.body.appendChild(form);

    const map = window.open("", "Map");

    if (map) {
      this.LoaderStatus = false;
      form.submit();
    } else {
      alert("You must allow popups for this map to work.");
    }
  }
  async LoginForm(TaxReturnFormID: any, FormTypeYear: any,TIN:any) {

    // if (FormTypeYear === 'BE 2025' || FormTypeYear === 'B 2025' || FormTypeYear === 'BT 2025' || FormTypeYear === 'M 2025' || FormTypeYear === 'MT 2025') {
    //   this.noticeDialog.blockButton();
    //   return;
    // }

    let shouldOpenWindow = true;
    this.LoaderStatus = true;
    let URL = "", EncUserName = "", EncUserIDNo = "", EncPassword = "", EncTAIDNo = "", EncTaxPayerItRefNo = "", EncYear = "", YearAssessment = "";
    let Params = {
      "FirmID": Number(this.SessionFirmID),
      "StaffID": Number(this.SessionStaffID),
      "TaxReturnFormID": Number(TaxReturnFormID)
    };
    const result = await this.apiServices.FormLogin(Params);
    if (result.hasError) {
      this.GetData(this.FormStatus, this.IDType, this.IDNo, this.YearAssessment, this.SessionFirmID, this.SessionStaffID, this.CheckNull(this.PageNum) ? null : this.PageNum, this.CheckNull(this.PageSize) ? null : this.PageSize);
      this.AlertType = "fail";
      this.AlertMessage = result.errMsg;
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      if (FormTypeYear.includes("CP204") || FormTypeYear.includes("CP204B")) {
        if (FormTypeYear.substring(0, FormTypeYear.indexOf("-")) == "CP204A")
          YearAssessment = FormTypeYear.substring(FormTypeYear.indexOf("-") + 1, FormTypeYear.lastIndexOf("-"));
        else
          YearAssessment = FormTypeYear.substring(FormTypeYear.lastIndexOf("-") + 1);
      } else {
        YearAssessment = FormTypeYear.substring(FormTypeYear.lastIndexOf(" ") + 1);
      }
      EncUserName = await this.EncryptDecryptText('201', this.SessionStaffIDNo);
      EncUserIDNo = await this.EncryptDecryptText('201', this.SessionStaffIDNo);
      EncPassword = await this.EncryptDecryptText('201', result.password);
      EncTAIDNo = await this.EncryptDecryptText('201', result.taxAgentICNo);
      EncTAIDNo = await this.EncryptDecryptText('201', result.taxAgentICNo);
      EncTAIDNo = await this.EncryptDecryptText('201', result.taxAgentICNo);
      EncYear = await this.EncryptDecryptText('201', result.taxAgentICNo);
      EncTaxPayerItRefNo = await this.EncryptDecryptText('201', TIN);
      let tempRoles = "";
      const Roles = JSON.parse(this.SessionRoles);
      Roles.forEach((currentValue: any, index: any) => {
        if (currentValue === "0202")
          tempRoles = "PENYELIA";
        else if (currentValue === "0203")
          tempRoles = "STAF";
        else if (currentValue === "0204")
          tempRoles = "EJEN CUKAI";
      });
      switch (result.formType) {
        case "P":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=P" + "&Tahun_Taksiran=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2021)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=P&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=P";
          break;
        case "E":
          if (Number(YearAssessment) >= 2022) 
            this.CreateCP8DForm(TaxReturnFormID, YearAssessment)

          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=E" + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2021)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=E&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=E";
          break;
        case "CP8D":
          const cp8dUrl: string = result.url;
          const urlObj = new window.URL(cp8dUrl);
          const token = sessionStorage.getItem('token');

          if (token) {
            urlObj.searchParams.set('signature', token);
          }

          URL = urlObj.toString();
          break;
        case "C":
          if (Number(YearAssessment) > 2025)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&Tahun_Taksiran=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2021)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType;
          break;
        case "C1":
          if (Number(YearAssessment) > 2025)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Tahun_Taksiran=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2020)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType;
          break;
        case "BNTC1":
          if (Number(YearAssessment) > 2020)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType;
          break;
        case "BNT C":
          if (Number(YearAssessment) > 2025)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&NoRujukan=" + EncTaxPayerItRefNo + "&Tahun_Taksiran=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2021)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&NoRujukan=" + EncTaxPayerItRefNo + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&NoRujukan=" + EncTaxPayerItRefNo;
          break;
        case "TF":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2019)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType;
          break;
        case "TP":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&IDType=1&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2019)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&IDType=1&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&IDType=1";
          break;
        case "TC":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment);
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "BNTTC":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment);
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "PT":
          if (Number(YearAssessment) > 2025)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Tahun_Taksiran=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2021)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "BNTPT":
          if (Number(YearAssessment) > 2021)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&Username=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "TA":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment);
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "BNTTA":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment);
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "TR":
          if (Number(YearAssessment) > 2025)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment);
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "BNTTR":
          URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "TJ":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&TahunTaksiran=" + await this.EncryptDecryptText('201', YearAssessment);
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "LE1":
          URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment);
          break;
        case "CP204":
          URL = result.url + "?IPAddress=" + this.SessionIPAddress + "&TaxReturnFormID=" + TaxReturnFormID +
            "&UserName=" + EncUserName + "&Password=" + EncPassword + "&FirmID=" + this.SessionFirmID +
            "&Nama=" + encodeURI(result.taxAgentName) + "&ID=" + EncTAIDNo + "&CompanyRefNo=" + EncTaxPayerItRefNo + "&Jenis_File=" + result.taxPayerFileType +
            "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + result.formType + "&Roc_No=" + encodeURI(result.taxPayerROC) + "&Jawatan=" + tempRoles + "&CompanyName=" + encodeURI(result.taxPayerName) +
            "&LicenseNo=" + result.taxAgentLicenseNo + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment);
          break;
        //ASAD TAMBAH CP204B 3.1.2024 
        case "CP204B":
          URL = result.url + "?IPAddress=" + this.SessionIPAddress + "&TaxReturnFormID=" + TaxReturnFormID +
            "&UserName=" + EncUserName + "&Password=" + EncPassword + "&FirmID=" + this.SessionFirmID +
            "&Nama=" + encodeURI(result.taxAgentName) + "&ID=" + EncTAIDNo + "&CompanyRefNo=" + EncTaxPayerItRefNo + "&Jenis_File=" + result.taxPayerFileType +
            "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + result.formType + "&Roc_No=" + encodeURI(result.taxPayerROC) + "&Jawatan=" + tempRoles + "&CompanyName=" + encodeURI(result.taxPayerName) +
            "&LicenseNo=" + result.taxAgentLicenseNo + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment);
          break;
        case "CP204A":
          URL = result.url + "?IPAddress=" + this.SessionIPAddress + "&TaxReturnFormID=" + TaxReturnFormID +
            "&UserName=" + EncUserName + "&Password=" + EncPassword + "&FirmID=" + this.SessionFirmID +
            "&Nama=" + encodeURI(result.taxAgentName) + "&ID=" + EncTAIDNo + "&CompanyRefNo=" + EncTaxPayerItRefNo + "&Jenis_File=" + result.taxPayerFileType +
            "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + result.formType + "&Roc_No=" + encodeURI(result.taxPayerROC) + "&Jawatan=" + tempRoles + "&CompanyName=" + encodeURI(result.taxPayerName) +
            "&LicenseNo=" + result.taxAgentLicenseNo + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment) + "&Pindaan=" + result.pindaan;
          break;
        case "CPP":
        case "CPE":
          if (Number(YearAssessment) > 2024)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment) + "&language=en-US";
          else if (Number(YearAssessment) > 2019)
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType) + "&language=en-US";
          else
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', result.formType);
          break;
        case "BNT CPP":
          let tempFormType = result.formType.replace(" ", "")
          URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + await this.EncryptDecryptText('201', tempFormType) + "&language=en-US";
          break;
        case "CKM":
          URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&Jenis_Sijil=" + result.certType + "&language=en-US";
          break;
        case "BE":
        case "B":
        case "BT":
        case "M":
        case "MT":
          if (Number(YearAssessment) >= this.yearBeStartOauth) {
            this.windowForm.openPostForm(result.url, {
              auth_type: "digicert",
              form_tin: TIN,
              form_type: result.formType,
              form_year: YearAssessment,
              cert_type: 2,
              TaxReturnFormID: TaxReturnFormID,
              language: "en-US",
            });
            shouldOpenWindow = false;
          } else {
            URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&ID=" + EncUserIDNo + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + result.formType + "&TaxReferenceNo=" + result.firmTaxRefNum;
          }
          break;
        case "PE":
        case "PB":
          this.windowForm.openPostForm(result.url, {
            auth_type: "digicert",
            form_tin: TIN,
            form_type: result.formType,
            form_year: YearAssessment,
            cert_type: 2,
            TaxReturnFormID: TaxReturnFormID,
            language: "en-US",
          });
          shouldOpenWindow = false;
          break;

        default: // IND
          URL = result.url + "?TaxReturnFormID=" + TaxReturnFormID + "&UserName=" + EncUserName + "&ID=" + EncUserIDNo + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + result.formType + "&TaxReferenceNo=" + result.firmTaxRefNum;
          break;
      }

      if (shouldOpenWindow && URL) {
        this.windowForm.openWindow(URL);  
      }

      this.LoaderStatus = false;
    }
  }
  async EncryptDecryptText(Type: any, Text: any) {
    let EncryptedText;
    const result = await this.apiServices.GetEncryptDecrypt(Type, Text);
    EncryptedText = JSON.parse(JSON.stringify(result));
    return EncryptedText;
  }
  //kena tambah untuk prod
  async CreateCP8DForm(TaxReturnFormID: any, FormYear:any) {
    //call api create cp8d

    let Params = {
      "taxReturnFormID": TaxReturnFormID,
      "formYear": FormYear
    }
    const result = await this.apiServices.CreateCP8D(Params);
  }
  CKMAcknowledgementValueSet(TIN : any) {
    this.CKMTINView = TIN;
  }
  openWindow(URL: any) {
    if (this.openedWindowStatus === null || this.openedWindowStatus.closed)
      this.openedWindowStatus = window.open(URL, "_blank");
    else
      this.openedWindowStatus.focus();
  }

   
}
